import React from "react"

/**
 * Recursively extracts text content from a JSX tree.
 *
 * @example
 * getTextFromJSX(<Button>Upgrade <strong>now</strong></Button>) // "Upgrade now"
 *
 * @param {React.ReactNode} node
 * @returns {string}
 */
export function extractText(node) {
  if ([null, undefined, true, false].includes(node)) {
    return ""
  }

  const parts = []

  React.Children.forEach(node, child => {
    if (typeof child === "string" || typeof child === "number") {
      parts.push(child)
    } else if (React.isValidElement(child)) {
      const text = extractText(child.props.children)
      if (text) parts.push(text)
    }
  })

  return parts.join(" ").replace(/\s+/g, " ") // normalize multiple spaces
}
